// @ts-check
/**
 * Typed client for care-management operations APIs.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['CareManagementOperationsRequest']} CareManagementOperationsRequest */
/** @typedef {Schemas['CareManagementOperationsResponse']} CareManagementOperationsResponse */
/** @typedef {Schemas['TeamAssignmentTeam']} TeamAssignmentTeam */

/**
 * GET /api/team-assignments/teams/ — list active care-manager teams for the
 * current tenant.
 *
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<TeamAssignmentTeam[]>}
 */
export async function getCareManagementTeams(config) {
  const { data } = await axios.get('/api/team-assignments/teams/', config)
  return data
}

/**
 * POST /api/care-management/operations/ — fetch operations data for the
 * selected date range, optionally limited to one or more team managers.
 *
 * @param {CareManagementOperationsRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<CareManagementOperationsResponse>}
 */
export async function fetchCareManagementOperations(body, config) {
  const { data } = await axios.post('/api/care-management/operations/', body, config)
  return data
}
